import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx } from "vue"

import { defineAsyncComponent, shallowRef, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';

import { accountService } from '@exchange/libs/account/service/src';
import { balanceService } from '@exchange/libs/balances/service/src';
import ConfirmJurisdictionModal from '@exchange/libs/jurisdiction/ConfirmJurisdictionModal.vue';
import RestrictedJurisdictionModal from '@exchange/libs/jurisdiction/RestrictedJurisdictionModal.vue';
import { modalVariant } from '@exchange/libs/modals/src';
import PublicRest from '@exchange/libs/rest-api/public-api';
import { useInitTransaction } from '@exchange/libs/transactions/funds/service/src';
import { AccountIsNotMain, CoinSelect, FetchBitpandaUser, UserBlocked, UserNotVerified, TransactionModal } from '@exchange/libs/transactions/shared/src';

import modalService from '../../../../modals/src/lib/modals.service';


export default /*#__PURE__*/_defineComponent({
  __name: 'Withdraw',
  setup(__props) {

const WithdrawCrypto = defineAsyncComponent(() => import(/* webpackChunkName: 'chunk-withdraw-crypto' */ './WithdrawCrypto.vue'));
const WithdrawFiat = defineAsyncComponent(() => import(/* webpackChunkName: 'chunk-withdraw-fiat' */ './WithdrawFiat.vue'));

const router = useRouter();
const route = useRoute();

const { list: balances } = balanceService;

const variant = modalVariant.dark;

const {
  currenciesToShow,
  defaultFiatCurrency,
  filterCurrencyList,
  getCurrencyFromRoute,
  isBlocked,
  isVerified,
  isMainAccount,
  isRetailWithMissingAml,
  resetSelectedCurrency,
  selectedCurrency,
  selectedCurrencyIsCrypto,
  search,
} = useInitTransaction();

const fiatRestricted = ref(false);

const showRestrictedJurisdictionModal = async () => {
  modalService.show(
    shallowRef(RestrictedJurisdictionModal),
    {
      variant,
      transactionType: 'withdraw',
    },
    {
      'action-clicked': () => modalService.hide(),
    },
    {
      canClose: false,
    },
  );
};

const showConfirmJurisdictionModal = async () => {
  modalService.show(
    shallowRef(ConfirmJurisdictionModal),
    {
      variant,
      transactionType: 'withdraw',
    },
    {
      'action-clicked': (code) => {
        modalService.hide();
        window.location.reload();
      },
    },
    {
      canClose: false,
    },
  );
};

const checkUserResidence = async () => {
  const user = await accountService.awaitAccountUser();
  const identity = await accountService.checkIdentity();
  const jurisdictions = await PublicRest.Jurisdictions.get();

  if (!identity?.residency) {
    await showConfirmJurisdictionModal();
  }

  if (jurisdictions[identity.residency]) {
    const jurisdiction = jurisdictions[identity.residency];
    if (jurisdiction.noFiatTransfers) {
      fiatRestricted.value = true;
      if (!selectedCurrencyIsCrypto.value) {
        await showRestrictedJurisdictionModal();
      }
    }
  }
};

(async () => {
  await getCurrencyFromRoute(route, router);
  await checkUserResidence();
})();

return (_ctx: any,_cache: any) => {
  const _component_ot_search = _resolveComponent("ot-search")!
  const _component_ot_transition_collapse = _resolveComponent("ot-transition-collapse")!

  return (_openBlock(), _createBlock(_unref(TransactionModal), {
    class: "withdraw-modal",
    name: "withdraw",
    variant: _unref(variant),
    title: _ctx.$t('modules.transactions.withdraw.title')
  }, {
    content: _withCtx(({ clear, searchClass, coinSelectClass, contentClass }) => [
      _createVNode(_unref(FetchBitpandaUser), { variant: _unref(variant) }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: _normalizeClass(["deposit-modal__search", searchClass])
          }, [
            _createVNode(_component_ot_search, {
              value: _unref(search),
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (_isRef(search) ? (search).value = $event : null)),
              variant: _unref(variant),
              "full-width": true,
              "on-search-cb": _unref(filterCurrencyList),
              onInputClick: _unref(resetSelectedCurrency)
            }, null, 8, ["value", "variant", "on-search-cb", "onInputClick"])
          ], 2),
          (!_unref(isMainAccount))
            ? (_openBlock(), _createBlock(_unref(AccountIsNotMain), {
                key: 0,
                operation: "withdraw",
                variant: _unref(variant),
                class: _normalizeClass(contentClass),
                onClose: clear
              }, null, 8, ["variant", "class", "onClose"]))
            : _createCommentVNode("", true),
          _createVNode(_unref(CoinSelect), {
            selectedCurrency: _unref(selectedCurrency),
            "onUpdate:selectedCurrency": _cache[1] || (_cache[1] = ($event: any) => (_isRef(selectedCurrency) ? (selectedCurrency).value = $event : null)),
            type: "withdraw",
            variant: _unref(variant),
            class: _normalizeClass(coinSelectClass),
            currencies: _unref(currenciesToShow),
            "default-fiat-currency": _unref(defaultFiatCurrency),
            balances: _unref(balances),
            "zero-balance-selectable": false,
            "fiat-selectable": !fiatRestricted.value
          }, null, 8, ["selectedCurrency", "variant", "class", "currencies", "default-fiat-currency", "balances", "fiat-selectable"]),
          _createVNode(_component_ot_transition_collapse, { duration: { enter: 500, leave: 0 } }, {
            default: _withCtx(() => [
              (_unref(selectedCurrency) && !_unref(isBlocked) && _unref(isVerified) && !_unref(isRetailWithMissingAml))
                ? (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(selectedCurrencyIsCrypto) ? _unref(WithdrawCrypto) : _unref(WithdrawFiat)), {
                    key: _unref(selectedCurrency).id,
                    variant: _unref(variant),
                    currency: _unref(selectedCurrency),
                    class: _normalizeClass(contentClass),
                    onClose: clear
                  }, null, 40, ["variant", "currency", "class", "onClose"]))
                : (_unref(selectedCurrency) && _unref(isBlocked))
                  ? (_openBlock(), _createBlock(_unref(UserBlocked), {
                      key: 1,
                      class: _normalizeClass(contentClass),
                      variant: _unref(variant),
                      onClose: clear
                    }, null, 8, ["class", "variant", "onClose"]))
                  : (_unref(selectedCurrency) && (!_unref(isVerified) || _unref(isRetailWithMissingAml)))
                    ? (_openBlock(), _createBlock(_unref(UserNotVerified), {
                        key: 2,
                        variant: _unref(variant),
                        "currency-symbol": _unref(selectedCurrency).id,
                        class: _normalizeClass(contentClass),
                        "text-key": "modules.transactions.verification.commonText",
                        "link-text-key": "modules.transactions.verification.button"
                      }, null, 8, ["variant", "currency-symbol", "class"]))
                    : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1024)
        ]),
        _: 2
      }, 1032, ["variant"])
    ]),
    _: 1
  }, 8, ["variant", "title"]))
}
}

})